import { css } from '@emotion/react'
import { ReactNode } from 'react'
import { AppBackgroundColor } from 'src/features/theme/KdsThemeColor'

type Props = {
  left: ReactNode
  right: ReactNode
  overlay?: ReactNode
}

export const SubHeader = ({ left, right, overlay }: Props) => {
  const isOverlayVisible = !!overlay

  return (
    <div css={styles.container}>
      <div css={styles.left}>{left}</div>
      <div css={styles.right}>{right}</div>
      {isOverlayVisible && <div css={styles.overlay}>{overlay}</div>}
    </div>
  )
}

const styles = {
  container: css`
    align-items: center;
    display: flex;
    height: 64px;
    justify-content: space-between;
    padding: 0 24px;
    position: relative;
  `,
  left: css`
    display: flex;
    align-items: center;
  `,
  right: css`
    display: flex;
    align-items: center;
    gap: 16px;
  `,
  overlay: css`
    background: ${AppBackgroundColor};
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  `,
}
